import { Icon } from "@iconify/react";
import { useMemo } from "react";
import { Label } from "../../components/shared/InputField";
import { Box, HStack, VStack } from "../../components/utils";
import { useGetOptionBuyback } from "../../queries/optionBuyback";

export type FilterProps = {
  onClose: () => void;
  id?: string;
};

function FilterDetails(props: FilterProps) {
  const { data: optionBuybackOverview } = useGetOptionBuyback();
  const { id, onClose } = props;

  const _id = id ?? "";
  const advanceFilters = useMemo(
    () =>
      optionBuybackOverview?.find((item) => (item?.id || "") === _id)
        ?.offerFilter,
    [id]
  );
  const optionBuyback = useMemo(
    () => optionBuybackOverview?.find((item) => (item?.id || "") === _id),
    [id]
  );

  return (
    <>
      <HStack className=" w-200 stone-700 justify-between p-4 px-10 mt-4 text-lg font-medium border-b border-solid">
        <Box>
          <h6>Advance Filters</h6>
        </Box>
        <Icon
          icon="ic:round-close"
          onClick={onClose}
          className="cursor-pointer"
        />
      </HStack>
      <Box className="p-4 px-10 border-solid">Employee Related Filters</Box>
      <VStack className="gap-8 p-4 px-10  border-b border-solid">
        <HStack className="justify-start gap-12">
          <VStack className="flex-1">
            <Label>Minimum Vested Options</Label>
            <Box>{advanceFilters?.minimumVestedOptions}</Box>
          </VStack>
          <VStack className="flex-1">
            <Label>Minimum Employment Tenure</Label>
            <Box>{advanceFilters?.minimumTenure}</Box>
          </VStack>
        </HStack>
        <HStack className="justify-start gap-12">
          <VStack className="flex-1">
            <Label>Ask willingness</Label>
            <Box>{optionBuyback?.askWillingness ? "Yes" : "No"}</Box>
          </VStack>
          <VStack className="flex-1">
            <Label>Minimum Willingness Percentage</Label>
            <Box>
              {(advanceFilters?.minimumWillingnessPercentage || 0) * 100}
            </Box>
          </VStack>
        </HStack>
        <HStack className="justify-start gap-12">
          <VStack className="flex-1">
            <Label>Department</Label>
            <HStack className="gap-2 p-2 max-w-[250px] overflow-auto ">
              {advanceFilters?.department?.map((dept, index) => (
                <Box key={index} className="bg-slate-300 p-2 rounded">
                  {dept}
                </Box>
              ))}
            </HStack>
          </VStack>
          <VStack className="flex-1">
            <Label>Minimum Willingness </Label>
            <Box>{advanceFilters?.minimumWillingness}</Box>
          </VStack>
        </HStack>
      </VStack>
      {(advanceFilters?.participationConstraints?.length ?? 0) > 0 && (
        <Box className="p-4 px-10 border-solid">Participation Constraints</Box>
      )}
      <VStack className=" gap-8 p-4">
        {advanceFilters?.participationConstraints?.map((pc, index) => (
          <HStack key={index}>
            <VStack className="flex-1">
              <Label>Maximum Number of Participation</Label>
              <Box>{pc.maxFrequency}</Box>
            </VStack>
            <VStack className="flex-1">
              <Label>Interval</Label>
              <Box>{pc.interval}</Box>
            </VStack>
            <VStack className="flex-1">
              <Label>Interval unit</Label>
              <Box>{pc.intervalUnit}</Box>
            </VStack>
          </HStack>
        ))}
      </VStack>
    </>
  );
}

export default FilterDetails;
